import { Toaster } from '@/components/ui/sonner';
import { useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';
import useLocalStorage from 'use-local-storage';

export default function RootLayout() {
  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [darkMode, _setDarkMode] = useLocalStorage(
    'theme',
    defaultDark ? 'dark' : 'light'
  );

  useLayoutEffect(() => {
    if (darkMode === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div>
      <Toaster />
      <Outlet />
    </div>
  );
}
